export const useSort = <Type>(sortKey: keyof Type) => {
  const sortAsc = (a: Type, b: Type) => (a[sortKey] < b[sortKey] ? -1 : 1);
  const sortDesc = (a: Type, b: Type) => (a[sortKey] > b[sortKey] ? -1 : 1);

  return { sortAsc, sortDesc };
};
